import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'c-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit {
  public items: MenuItem[];
  public title: string;

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private translate: TranslateService) {
    this.items = [];
  }

  ngOnInit() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const root: ActivatedRoute = this.activatedRoute.root;
      this.items = this.getBreadcrumbs(root, []);
    });
  }

  private getBreadcrumbs(route: ActivatedRoute, breadcrumbs: MenuItem[]): MenuItem[] {
    const children: ActivatedRoute[] = route.children;
    if (children.length === 0) {
      return breadcrumbs;
    }

    this.generateBreadcrumb(children, breadcrumbs);

    const index = (breadcrumbs.length && breadcrumbs.length - 1) || 0;
    this.title = breadcrumbs[index] && breadcrumbs[index].label;
    return breadcrumbs;
  }

  private generateBreadcrumb(children: ActivatedRoute[], breadcrumbs: MenuItem[]) {
    const ROUTE_DATA_BREADCRUMB = 'breadcrumb';
    children.forEach((child: ActivatedRoute, index: number) => {
      if (child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
        child.snapshot.data[ROUTE_DATA_BREADCRUMB].map(val => {
          const breadcrumb: MenuItem = {
            label: this.translate.instant(val.name),
            queryParams: child.snapshot.queryParams,
            routerLink: this.getFormattedUrl(child, val.routerLink),
            url: this.getFormattedUrl(child, val.url)
          };

          if (val.routerLink) {
            breadcrumb.disabled = true;
            breadcrumb.routerLinkActiveOptions = { exact: true };
          }
          breadcrumbs.push(breadcrumb);
        });
      }

      if (child.children && child.children.length) {
        this.generateBreadcrumb(child.children, breadcrumbs);
      }
    });
  }

  getFormattedUrl(activatedRoute: ActivatedRoute, url: string): string {
    if (url) {
      Object.keys(activatedRoute.snapshot.params).forEach(param => {
        url = url.replace(`:${param}`, activatedRoute.snapshot.params[param]);
      });

      if (url.includes(':') && activatedRoute.parent) {
        return this.getFormattedUrl(activatedRoute.parent, url);
      }
    }
    return url;
  }
}
